import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-zinc-200 text-[#141416] pt-16 pb-12 shadow-[0_-4px_24px_rgba(0,0,0,0.03)]">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 pb-16 border-b border-zinc-200">
          {/* Brand & Storytelling (col 1-5) */}
          <div className="lg:col-span-5 space-y-6">
            <Link to="/" className="inline-block focus:outline-none" aria-label="Lunde Media">
              <Logo size="lg" variant="dark" />
            </Link>
            <p className="text-zinc-600 text-sm md:text-base leading-relaxed max-w-md font-sans">
              Lunde Media drives af Michael med en passion for at fange de ægte øjeblikke, relationer og stemninger, der ikke kan genskabes. Billeder og video med nærvær, autencitet og historie.
            </p>
            <div className="pt-2">
              <a
                href="https://www.facebook.com/Lundemedia/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-medium text-zinc-700 hover:text-black transition-colors"
                aria-label="Følg Lunde Media på Facebook"
              >
                <i className="fa-brands fa-facebook text-lg text-black" aria-hidden="true" />
                <span>Følg med på Facebook</span>
              </a>
            </div>
          </div>

          {/* Ydelser / Navigation (col 6-8) */}
          <div className="lg:col-span-3 space-y-4">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#141416]">
              Fotografi & Video
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/bryllupper"
                  className="text-zinc-600 hover:text-black transition-colors block"
                >
                  Bryllupper & Bryllupspakker
                </Link>
              </li>
              <li>
                <Link
                  to="/cykelloeb"
                  className="text-zinc-600 hover:text-black transition-colors block"
                >
                  Cykelløb & Sport
                </Link>
              </li>
              <li>
                <Link
                  to="/events"
                  className="text-zinc-600 hover:text-black transition-colors block"
                >
                  Events & Erhverv
                </Link>
              </li>
              <li>
                <Link
                  to="/branding"
                  className="text-zinc-600 hover:text-black transition-colors block"
                >
                  Branding & Markedsføring
                </Link>
              </li>
              <li>
                <Link
                  to="/familiefotografering"
                  className="text-zinc-600 hover:text-black transition-colors block"
                >
                  Familiefotografering
                </Link>
              </li>
              <li>
                <Link
                  to="/storytelling"
                  className="text-zinc-600 hover:text-black transition-colors block font-medium text-black"
                >
                  Storytelling
                </Link>
              </li>
              <li>
                <Link
                  to="/om-lunde-media"
                  className="text-zinc-600 hover:text-black transition-colors block"
                >
                  Om Lunde Media
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="text-zinc-600 hover:text-black transition-colors block"
                >
                  Kontakt & Booking
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Details (col 9-12) */}
          <div className="lg:col-span-4 space-y-4">
            <h3 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#141416]">
              Kontakt Oplysninger
            </h3>
            <div className="space-y-3.5 text-sm text-zinc-700">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-phone text-[#141416] text-sm mt-1" aria-hidden="true" />
                <div>
                  <a
                    href="tel:26368306"
                    className="font-medium text-[#141416] hover:text-black transition-colors whitespace-nowrap inline-block"
                  >
                    26 36 83 06
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="fa-solid fa-envelope text-[#141416] text-sm mt-1" aria-hidden="true" />
                <div>
                  <a
                    href="mailto:Kontakt@lundemedia.dk"
                    className="font-medium text-[#141416] hover:text-black transition-colors whitespace-nowrap inline-block"
                  >
                    Kontakt@lundemedia.dk
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#141416] text-sm mt-1" aria-hidden="true" />
                <div>
                  <p className="text-zinc-800 font-medium">
                    Kolding
                  </p>
                  <span className="text-xs text-zinc-500 mt-1 inline-block">
                    Dækker opgaver i hele Danmark efter aftale
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-zinc-500">
          <div>
            © {currentYear} Lunde Media. Alle rettigheder forbeholdes.
          </div>
        </div>
      </div>
    </footer>
  );
}
